import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { number, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, Campo, Selecao } from 'Component/Form';
import Icone from 'Component/Icone';
import LayoutDefault from 'Component/Layout';
import Banco from 'Interface/Bancos';
import { MASCARA_TELEFONE, TIPOS_DE_CONTA } from 'View/constants';
import {
  useEditarBancoMutation,
  useRecuperarBancoQuery
} from 'View/Service/Default/Bancos';

const regras = object({
  codigo: string().required('Obrigatório'),
  nome: string().required('Obrigatório'),
  agencia: string().required('Obrigatório'),
  conta: string().required('Obrigatório'),
  tipo: number().required('Obrigatório'),
  telefone: string().nullable().optional(),
  endereco: string().nullable().optional(),
  gerente: string().nullable().optional(),
});

const Editar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const { id = 0 } = useParams();
  const [editarBanco] = useEditarBancoMutation();

  const { data: { banco } = {} } = useRecuperarBancoQuery(id);

  const enviar = async (dados: Banco): Promise<void> => {
    try {
      await editarBanco(dados).unwrap();

      toast({ conteudo: 'Editado com sucesso!', tema: 'success' });

      navegacao(`/${banco?.entidade}/editar/${banco?.entidade_id}`);
    } catch (error) {
      toast({
        titulo: 'Erro ao editar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Editando banco"
        descricao="Preencha o formulário e clique em enviar para editar o banco"
      />
      <Form onSubmit={enviar} regras={regras} inicial={banco}>
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="bg-white shadow-sm rounded p-4">
              <div className="row">
                <div className="col-md-4">
                  <Campo name="codigo" rotulo="Código do banco" />
                </div>
                <div className="col-md-8">
                  <Campo name="nome" rotulo="Nome do banco" />
                </div>
                <div className="col-md-4">
                  <Campo name="agencia" rotulo="Agência" />
                </div>
                <div className="col-md-4">
                  <Campo name="conta" rotulo="Conta" />
                </div>
                <div className="col-md-4">
                  <Selecao
                    name="tipo"
                    opcoes={TIPOS_DE_CONTA}
                    rotulo="Tipo da conta"
                  />
                </div>
                <div className="col-md-5">
                  <Campo
                    name="endereco"
                    rotulo="Endereço"
                    prefixar={<Icone nome="pin-map-fill" />}
                  />
                </div>
                <div className="col-md-4">
                  <Campo
                    name="telefone"
                    rotulo="Telefone"
                    mascara={MASCARA_TELEFONE}
                    prefixar={<Icone nome="telephone-fill" />}
                  />
                </div>
                <div className="col-md-3">
                  <Campo name="gerente" rotulo="Nome do gerente" />
                </div>
              </div>

              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink
                  tema="light"
                  to={`/${banco?.entidade}/editar/${banco?.entidade_id}`}
                  className="ms-2"
                >
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Editar;
